import { categoryId } from "../../../utils/constants";
import { dimTypeT } from "../../../utils/functions/playcanvas/playerSettings";
import { deepCopy } from "../../../utils/objUtils";
import { envOptoinsT, stateT } from "../types";

export const getActiveTab =
  () =>
    ({ ...state }: stateT) => {
      const activeTab: categoryId | undefined = state.ui.activeTab;
      return activeTab;
    };

export const getSelectedModel =
  () =>
    ({ ...state }: stateT) => {
      const selectedModel: boolean = state.ui.selectedModel;
      const selectedType: dimTypeT = state.ui.selectedType;
      return { selectedModel, selectedType };
    };

export const getRenderHash =
  () =>
    ({ ...state }: stateT) => {
      const renderHash: any = state.ui.renderHash;
      return renderHash;
    };

/**
 *
 * @deprecated this old selectors and property products, see objects
 *
 */
export const getProducts =
  () =>
    ({ ...state }: stateT) => {
      // const products: any = state.ui.products;
      // return products;
      return [];
    };
export const getEnvironments =
  () =>
    ({ ...state }: stateT) => {
      const environments: any = state.ui.environments;
      return environments;
    };

export const getEnvironmentVariant =
  (nameEnv: envOptoinsT) =>
    ({ ...state }: stateT) => {
      if (nameEnv) {
        const environmentVariant: any = state.ui.selectedVariants[nameEnv];
        return environmentVariant;
      }
    };

/**
 *
 * @deprecated this old selectors and property Categories, see folders
 *
 */
export const getCategories =
  () =>
    ({ ...state }: stateT) => {
      // const categories: any = state.ui.categories;
      // return categories;
      return [];
    };

export const getActiveEnvironmentId =
  () =>
    ({ ...state }: stateT) => {
      const activeEnvironmentIndex: number = state.ui.activeEnvironmentId;
      return activeEnvironmentIndex;
    };

export const getActiveObjectIndex =
  () =>
    ({ ...state }: stateT) => {
      const activeObjectIndex: string | null = state.ui.activeObjectId;
      return activeObjectIndex;
    };

export const getUIState = ({ ...state }: stateT) => {
  const uiState = {
    activeEnvironmentIndex: state.ui.activeEnvironmentId,
    environmentActiveValues: state.ui.environmentActiveValues,
    activeObjectIndex: state.ui.activeObjectId,
    selectedModel: state.ui.selectedModel,
    selectedType: state.ui.selectedType,
    activeTab: state.ui.activeTab,
    selectedVariants: state.ui.selectedVariants,

    selectObjects: deepCopy(state.ui.selectObjects),
  };
  return uiState;
};

export const getAspectRatio = ({ ...state }: stateT) => {
  return state.ui.screenSettings.aspectRatio;
};

export const getQuality = ({ ...state }: stateT) => {
  return state.ui.screenSettings.quality;
};

export const getWrapperDimensions = ({ ...state }: stateT) => {
  return state.ui.screenSettings.wrapperDimensions;
};

export const getCamera = ({ ...state }: stateT) => {
  return state.ui.camera;
};

export const getCameraEnabledSettings = ({ ...state }: stateT) => {
  return state.ui.camera.enabledSettings;
};

export const getTemplateFolders =
  () =>
    ({ ...state }: stateT) => {
      const templateFolders = state.ui.templateFolders;
      return templateFolders;
    };

export const getTemplates =
  () =>
    ({ ...state }: stateT) => {
      return state.ui.templates;
    };

export const getIsTemplatesLoading =
  () =>
    ({ ...state }: stateT) => {
      return state.ui.isTemplatesLoading;
    };

export const getTemplatesError =
  () =>
    ({ ...state }: stateT) => {
      return state.ui.templatesError;
    };

export const getCurrentStage =
  () =>
    ({ ...state }: stateT) => {
      return state.ui;
    };

export const getCurrentTemplate = ({ ...state }: stateT) => {
  return state.ui.currentTemplate;
};

export const getCurrentTemplatePresets = ({ ...state }: stateT) => {
  return state.ui.currentTemplatePresets;
};

export const getEnvironmentActiveValues = ({ ...state }: stateT) => {
  return state.ui.environmentActiveValues;
};
